var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4395 33.216C44.9892 29.9384 41.8018 27.6488 38.1254 27.6488C33.0944 27.6488 28.978 31.9364 28.978 37.1767",
    stroke: "#DF1995",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9505 27.5814C41.7553 27.1262 43.66 24.4835 43.2048 21.6787C42.7496 18.874 40.1069 16.9693 37.3021 17.4245C34.4974 17.8796 32.5926 20.5224 33.0478 23.3271C33.503 26.1319 36.1458 28.0366 38.9505 27.5814Z",
    stroke: "#DF1995",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9781 37.1767C28.9781 31.9365 24.8618 27.6488 19.8307 27.6488C16.1543 27.6488 12.9669 29.9384 11.5166 33.216",
    stroke: "#DF1995",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0132 27.5084C23.7784 26.8554 25.4908 24.0844 24.8378 21.3191C24.1849 18.5538 21.4139 16.8414 18.6486 17.4944C15.8833 18.1474 14.1709 20.9184 14.8239 23.6837C15.4769 26.449 18.2479 28.1613 21.0132 27.5084Z",
    stroke: "#DF1995",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.476 0.214478H43.48C45.3206 0.214478 46.8266 1.72101 46.8266 3.56109V8.99197C46.8266 10.8323 45.3203 12.3386 43.48 12.3386H31.689L28.7324 15.853L25.7757 12.3386H14.476C12.6357 12.3386 11.1294 10.8326 11.1294 8.99197V3.56109C11.1294 1.72045 12.6354 0.214478 14.476 0.214478Z",
    fill: "url(#paint0_linear_29_278)",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1256 53.1929C38.1256 47.9528 34.0093 43.665 28.9782 43.665C23.9471 43.665 19.8308 47.9525 19.8308 53.1929V55.0992H38.1256V53.1929Z",
    fill: "#F9C8D6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1256 53.1929C38.1256 47.9528 34.0093 43.665 28.9782 43.665C23.9471 43.665 19.8308 47.9525 19.8308 53.1929V55.0992H38.1256V53.1929Z",
    fill: "url(#paint1_linear_29_278)",
    fillOpacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1608 43.5232C32.9261 42.8702 34.6384 40.0992 33.9855 37.3339C33.3325 34.5686 30.5615 32.8563 27.7962 33.5092C25.0309 34.1622 23.3186 36.9332 23.9715 39.6985C24.6245 42.4638 27.3955 44.1761 30.1608 43.5232Z",
    fill: "#F9C8D6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1608 43.5232C32.9261 42.8702 34.6384 40.0992 33.9855 37.3339C33.3325 34.5686 30.5615 32.8563 27.7962 33.5092C25.0309 34.1622 23.3186 36.9332 23.9715 39.6985C24.6245 42.4638 27.3955 44.1761 30.1608 43.5232Z",
    fill: "url(#paint2_linear_29_278)",
    fillOpacity: 0.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.978 6.27655H28.9791",
    stroke: "#DF1995",
    strokeWidth: 2,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4004 6.27655H23.4015",
    stroke: "#DF1995",
    strokeWidth: 2,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8225 6.27655H17.8239",
    stroke: "#DF1995",
    strokeWidth: 2,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1328 6.27655H40.1342",
    stroke: "#DF1995",
    strokeWidth: 2,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5549 6.27655H34.556",
    stroke: "#DF1995",
    strokeWidth: 2,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8307 54.5415V53.1929C19.8307 47.9527 15.7144 43.665 10.6833 43.665C5.65222 43.665 1.53589 47.9525 1.53589 53.1929V55.0992H56.4203V53.1929C56.4203 47.9527 52.304 43.665 47.2729 43.665C42.2419 43.665 38.1255 47.9525 38.1255 53.1929V54.5415",
    stroke: "#DF1995",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5084 43.5982C14.3132 43.143 16.2179 40.5003 15.7627 37.6955C15.3075 34.8907 12.6648 32.986 9.85998 33.4412C7.05521 33.8964 5.1505 36.5392 5.6057 39.3439C6.0609 42.1487 8.70362 44.0534 11.5084 43.5982Z",
    stroke: "#DF1995",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0985 43.5975C50.9033 43.1423 52.808 40.4996 52.3528 37.6948C51.8976 34.89 49.2548 32.9853 46.4501 33.4405C43.6453 33.8957 41.7406 36.5384 42.1958 39.3432C42.651 42.148 45.2937 44.0527 48.0985 43.5975Z",
    stroke: "#DF1995",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_278",
    x1: 28.978,
    y1: 0.214478,
    x2: 28.978,
    y2: 18.1777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF1995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29_278",
    x1: 28.9782,
    y1: 33.3704,
    x2: 28.9782,
    y2: 58.3294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF1995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29_278",
    x1: 28.9782,
    y1: 33.3704,
    x2: 28.9782,
    y2: 58.3294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF1995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon4);
export default __webpack_public_path__ + "static/media/feature-icon4.acad127aea5f98b3db022023cb5bbdbe.svg";
export { ForwardRef as ReactComponent };